<template>
  <div class="input-modal-wrapper" ref="wrapper">
    <div class="input-modal overlay" v-if="visible" @touchmove.prevent="">
      <div class="input-form" ref="inputModalRef">
        <div class="title">
          <span>{{ title }} </span>
          <span class="arrow-btn" @mousedown="onCloseClick">
            <van-icon name="arrow-down" />
          </span>
        </div>
        <div class="input-wrapper">
          <van-field
            v-model="userInput"
            :clearable="true"
            :type="type"
            :maxlength="maxLength"
            :placeholder="placeholder"
            enterkeyhint="done"
            @focus="onInputFocus"
            @blur="onInputBlur"
            @keydown.enter.stop="onInputConfirm"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import inputModalMixin from "@/mixins/input-modal-mixin";

export default {
  props: {
    visible: {
      // 弹窗是否可见
      type: Boolean,
      default: false,
    },
    type: {
      // 键盘类型
      type: String,
      default: "number",
    },
    maxLength: {
      // 键盘类型
      type: Number,
      default: 200,
    },
    defaultValue: {
      // 默认值
      type: [Number, String],
      default: "",
    },
    title: {
      // 弹窗标题
      type: String,
      default: "请输入:",
    },
    placeholder: {
      // 输入框placeholder
      type: String,
      default: "",
    },
    allowNull: {
      // 是否允许输入空值
      type: Boolean,
      default: false,
    },
  },
  mixins: [inputModalMixin],
  data() {
    this.isCancel = false; // 是否放弃提交，用户点击收起按钮，视为放弃
    return {
      userInput: "", // 用户输入
      timer: null
    };
  },
  mounted() {
    // 将弹窗挂载到body下面
    document.body.appendChild(this.$refs.wrapper);
  },
  watch: {
    visible: {
      immediate: true,
      handler() {
        if (this.visible) {
          this.reset(); // 重新输入
          if (this.defaultValue) {
            this.userInput = this.defaultValue;
          }
          this.showKeyboard(); // 显示键盘
        }
      },
    },
  },
  methods: {
    // 重置组件状态
    reset() {
      this.userInput = "";
      this.isCancel = false;
    },
    // 放弃输入
    onCloseClick() {
      this.isCancel = true;
    },
    // 避免重复调用
    debounce(fn,delay = 3000,userInput="",timer = 'timer') {
      if (this[timer]) {
        clearTimeout(this[timer])
        this[timer] = null
      }
      this[timer] = setTimeout(() => {
        fn.call(this,userInput)
        clearTimeout(this[timer])
        this[timer] = null
      },delay)
    },
    // 确认输入
    onInputConfirm() {
      
      let userInput=this.userInput
      this.debounce(this.confirmFun,50,userInput)
    },
    // 确认输入事件
    confirmFun(userInput) {
      this.$emit("update:visible",false);
      if (!this.isCancel &&(userInput||this.allowNull)) {
        // 不是放弃&&有输入内容
        this.$emit("confirm",userInput);
      }
    },
    // 聚焦事件
    onInputFocus() {
      // 显示输入框
      this.showInputModal({
        keyboardType: this.type,
      });
    },
    // 失焦事件
    onInputBlur() {
      this.onInputConfirm();
    },
    // 安卓键盘收起
    onAndroidKeyboardDownEvent() {
      // this.isCancel = true;
      console.log("onAndroidKeyboardDownEvent");
      this.$emit("update:visible",false);
      // this.onInputConfirm();
    },
  },
};
</script>
<style lang="less" scoped>
.input-modal {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  &.overlay {
    top: 0;
    background: rgba(0, 0, 0, 0.5);
  }
}
.input-form {
  box-sizing: border-box;
  height: 165px;
  padding: 18px 0;
  position: absolute;
  left: 0;
  right: 0;
  // top: 0;
  z-index: 2000;
  background: #f2f2f7;
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 32px;
    margin-bottom: 5px;
    height: 60px;
    font-size: 28px;
    font-family: 'HarmonyOS_Sans_SC';
    font-weight: 500;
    color: #333;
    line-height: 40px;
    .arrow-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 20px;
      width: 48px;
      height: 44px;
    }
  }
  .input-wrapper {
    padding: 0 32px;
    /deep/.van-cell {
      padding-top: 0;
      padding-bottom: 0;
      padding-right: 24px;
      height: 64px;
      align-items: center;
      border-radius: 10px;
    }
    /deep/.van-field__value {
      height: 48px;
    }
    /deep/.van-field__control {
      font-size: 28px;
      font-family: 'HarmonyOS_Sans_SC';
      font-weight: 400;
      color: #333;
      line-height: 50px;
    }
  }
}
</style>